module.exports = __webpack_public_path__ + "קבוצת ידיעות - תקנון פעילות קיימות סופי -24.5.2021.pdf";